import { authorization } from 'Module/Auth/Auth'
import { useWrappedPosthog } from 'Components/PostHogProvider/hooks'
import { AnalyticsEventEmitter } from 'Utils/Analytics/AnalyticsEventEmitter'
import { CAMPAIGN_TYPE_PARAM_TO_CHANNEL } from 'shared/constants'

const usePosthogAnalyticsH2H = () => {
  const posthog = useWrappedPosthog()

  const emitAnalyticsEvent = () => {
    const user = authorization.getUser()
    const eventEmitter = new AnalyticsEventEmitter(posthog)
    eventEmitter.run({
      eventName: 'Clicked on CTA campaign empty state page',
      userId: user.id,
      clientName: user.client.name,
      additionalPayload: {
        channel: CAMPAIGN_TYPE_PARAM_TO_CHANNEL['h2h'],
      },
    })
  }
  return { emitAnalyticsEvent }
}

export default usePosthogAnalyticsH2H
